module.exports = __webpack_public_path__ + "static/media/spocket-logo-no-text.eb939fcb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spocket-logo-no-text.svg
// module id = 1795
// module chunks = 0